module.exports = __webpack_public_path__ + "static/img/image084.4888e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image084.png
// module id = XFij
// module chunks = 1